export const RequiredModels = (): null => {
  // Setup modal and notifications are managed centrally in TopNotifications
  return null;
};
